import {Injectable} from '@angular/core';
import {GenericCrudService} from '@gatewee/services/generic-crud.service';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {FinancialSummary, Transaction} from '@gatewee/types/transaction';

@Injectable({
  providedIn: 'root',
})
export class TransactionsService extends GenericCrudService<Transaction> {
  constructor(public override http: HttpClient) {
    super('/transactions/recipient', http);
  }

  financialSummary(): Observable<FinancialSummary> {
    return this.http
      .get<FinancialSummary>(this.baseUrl + '/financial-summary')
      .pipe();
  }
}
